// 云客消息枚举维护
const ENUM_MESSAGE_TYPE = {
  ALL: {
    type: 0,
    memo: '全部类型'
  },
  // 文本类型
  TEXT: {
    type: 1,
    memo: '文本'
  },
  // 图片类型
  IMAGE: {
    type: 2,
    memo: '图片'
  },
  // 短语音类型
  VOICE: {
    type: 3,
    memo: '短语音'
  },
  // 视频类型
  VIDEO: {
    type: 4,
    memo: '视频'
  },
  // GIF类型
  GIF: {
    type: 8,
    memo: 'GIF'
  },
  // 文件类型
  FILE: {
    type: 9,
    memo: '文件'
  },
  // 链接类型
  LINK: {
    type: 10,
    memo: '链接'
  },
  // 个人名片
  PERSONAL_CARD: {
    type: 13,
    memo: '个人名片'
  },
  // 定位类型
  LOCATION: {
    type: 14,
    memo: '定位'
  },
  // 系统消息
  SYSTEM_MESSAGE: {
    type: 15,
    memo: '系统消息'
  },
  // 小程序
  MINI_PROGRAM: {
    type: 18,
    memo: '小程序'
  },
  // 引用类型
  QUOTE: {
    type: 21,
    memo: '引用'
  },
  // 拍一拍
  POKE: {
    type: 22,
    memo: '拍一拍'
  },
  // 音视频
  AUDIO_VISUAL: {
    type: 50,
    memo: '音视频'
  }
}

const ENUM_MESSAGE_TYPE_MAP = Object.values(ENUM_MESSAGE_TYPE).reduce((result, item) => {
  result[item.type] = item
  return result
}, {})

export { ENUM_MESSAGE_TYPE, ENUM_MESSAGE_TYPE_MAP }
